// extracted by mini-css-extract-plugin
export default {"btn-delete":"btn-delete__lKlmi","btnDelete":"btn-delete__lKlmi","icon-wrapper":"icon-wrapper__19San","iconWrapper":"icon-wrapper__19San"};